document.querySelectorAll('[data-tab-trigger]').forEach((trigger) => {
  trigger.addEventListener('click', () => {
    const container = trigger.closest('.product-tabs');
    if (!container) return;
    container.querySelectorAll('[data-tab-trigger]').forEach((t) => {
      t.classList.toggle('is-active', t === trigger);
      t.setAttribute('aria-selected', t === trigger);
    });
    container.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== trigger.dataset.tabTrigger;
    });
  });
});
